export default class CheckboxGroupBuilder {
  group: HTMLElement;
  data: Object;

  /**
   * Create a new FilterGroup Builder
   */
  constructor(template: HTMLElement, data: Object) {
    this.group = template;
    this.data = data;
  }

  /**
   * Build the filter group its HTML
   */
  build(): HTMLElement {
    throw new Error('Abstract method');
  }
}
